import {frontend} from 'pageflow-scrolled/frontend';
import {DefaultNavigationPresenceProvider} from 'pageflow-scrolled/widgets/defaultNavigation';

import {Navigation} from './Navigation';

frontend.widgetTypes.register('chapterMenuNavigation', {
  component: Navigation,
  presenceProvider: DefaultNavigationPresenceProvider
});
